const SENSITIVE_KEY = /password|secret|token|api_?key/i
const REDACTED = '[redacted]'

export const isAuthEndpoint = (url: string): boolean => url.split(/[?#]/)[0].includes('/auth/')

export const redactSensitiveFields = (value: unknown): unknown => {
	if (Array.isArray(value)) {
		return value.map(redactSensitiveFields)
	}
	if (typeof value !== 'object' || value === null) {
		return value
	}
	return Object.fromEntries(
		Object.entries(value).map((
			[key, field],
		) => [key, SENSITIVE_KEY.test(key) ? REDACTED : redactSensitiveFields(field)]),
	)
}
